export default function Modal({ title, onClose, children }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <div className="modal-header">
          <b style={{ fontSize: 16 }}>{title}</b>
          <button onClick={onClose}
            style={{ background:"none",border:"none",fontSize:22,cursor:"pointer",color:"#999" }}>
            ×
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
